import { Component } from "~/ecs/base"
import { Bloom2 } from "./Bloom2"

export class Bloom2Active extends Component {
  static activator = Bloom2
}
